import { ILender }    from '@modules/admin/AdminTools/Workflows/types';
import { IGapLoanPaidOffRequestInformation } from '@modules/admin/Tools/shared/interfaces';
import { ECheckType } from '@shared/interfaces';

export interface ICheckRequest {
  requestId: string;
  dealId: string;
  achRefNumber: string;
  customerRefundAmount: number | null;
  cancellationDate: string;
  dealNumericId: string,
  productType: string;
  provider: string;
  decisionComment: string;
  requestedDate: string;
  requestedBy: string;
  requestComment: string | null,
  requestNumericId: string,
  customerName: string;
  loanConsultant: string;
  payeeName: string;
  amountRequested: number;
  legacyDealId: string;
  statusCD: string;
  reason: string;
  assetDesc: string;
  assetTag: string;
  checkRequestType: string;
  checkStatus?: string;
  payoffSubmittedDate?: Date;
  VIN : string;
  sellerRefundAmount: number | null;
}

export interface ICreateCheckRequest {
  dealId: string;
  requestedBy: string;
  createdBy: string;
  customerName: string | null;
  loanConsultant: string | null;
  payeeName: string | null;
  amountRequested: number | null;
  includeInBatch: boolean;
  relatedDeal: string | null;
  reason: string;
  assetTag: string | null;
  checkRequestType: number;
  checkStatus?: string;
  productType: string;
  provider: string;
  lenderCode: string;
  sellerAmountRefund: string | null;
  customerAmountRefund: string | null;
  cancelledDate: string;
  achRefNumber: string;
  requestComment: string;
  productCancellationId?: string;
  IsApproved?: boolean;
}

export interface IActionButtonProps {
  onClick?() : void;
  title      : string;
}

export interface IProcessCheck {
  checkRequestId?   : string;
  dealId?           : string;
  checkStatus?      : number;
  checkRequestType? : number;
}

export type ICheckStatus = {
  [key in ECheckType]: {
    status           : string;
    fn               : (path: string, data: ICheckRequest, checkRequestType: number) => void;
    apiURL           : string;
    checkRequestType : number;
  };
};

export enum CheckStatus {
  AddComment     = 1,
	Submitted      = 2,
	Approved       = 3,
	Declined       = 4,
	CheckCut       = 5,
	CheckVoid      = 6,
	CheckProcessed = 7,
	DownloadPdf    = 8,
	Sent           = 9
}

export enum ECheckRequest {
  Check = 1,
  Product,
  AtRefundCheck,
}

export enum CheckRequestConfigureSubGroup {
  CheckRequest = 'check-requests',
  CheckCut = 'check-cut',
  CheckSent = 'check-sent',
  CheckDeclined = 'check-declined',
  CheckVoid = 'check-void',
  ProductCheckRequest = 'product-check-requests',
  ProductCheckRequestCut = 'product-check-requests-cut',
  ProductCheckRequestDeclined = 'product-check-requests-declined',
  ATRefundCheck = 'at-refund-check'
}

export enum EProductType {
  Unknown = 'Unknown',
  Gap     = 'GAP',
  Vsc     = 'VSC',
  Com     = 'COM',
  Paf     = 'PAF',
  Vrp     = 'VRP',
}

export enum EReasonForCancellation {
  CommercialUseOnly      = 'Commercial Use VSC Only',
  CustomerRequest        = 'Customer Request',
  DealerVoidRequest      = 'Dealer Void Request',
  DeniedGapRequest       = 'Denied GAP Request - No GAP',
  DuplicatedContract     = 'Duplicated Contract',
  FlatCancelAndReissued  = 'Flat Cancel And Reissued (Only)',
  FlatCancelOrReissue    = 'Flat Cancel/Reissue',
  IneligibleContract     = 'Ineligible Contract',
  LemonLaw               = 'Lemon Law',
  LoanPaidOff            = 'Loan Paid Off',
  ModificationVSCOnly    = 'Modification VSC Only',
  Modified               = 'Modified',
  Other                  = 'Other',
  PaidLien               = 'Paid Lien',
  Refinanced             = 'Refinanced',
  Repossession           = 'Repossession',
  Sold                   = 'Sold',
  Stolen                 = 'Stolen',
  TotalLoss              = 'Total Loss',
  TotalLossOfVehicle     = 'Total Loss Of Vehicle',
  TPACancellationRequest = 'TPA Cancellation Request',
  Trade                  = 'Trade',
  Unwound                = 'Unwound',
  UnwoundDeal            = 'Unwound Deal',
  VehicleSoldOrTraded    = 'Vehicle Sold/Traded'
}

export const productTypes = Object.entries(EProductType).map(([key, value]) => ({
  label: value,
  value: key,
}));

export const cancellationReasons = Object.entries(EReasonForCancellation).map(([key, value]) => ({
  label: value,
  value: key,
}));

export interface IPayeeData {
  id                : string;
  payeeName         : string
  acumaticaVendorId : null | string
}

export interface ICustomCheckRequestFormValues {
  customerName         : string;
  legacyDealId         : string;
  productType          : string;
  provider             : string;
  lenderCode           : string;
  isPayeeLender        : boolean;
  payeeName            : string;
  address              : string;
  customerAmountRefund : number;
  sellerAmountRefund   : number;
  amountRequested      : number;
  cancelledDate        : string | Date;
  achRefNumber         : string;
  reason               : string;
  requestComment       : string;
}

export interface ICustomCheckRequestFormProps {
  lenderOptions : ILender[];
  lendersError  : boolean;
  payeeData     : IPayeeLender[];
}

export interface IPayeeLender {
  id: string;
  lenderId: string;
  lenderName: string;
  payeeName: string;
  payeeAddress: string;
  payeeState: string | null;
  payeeZip: string | null;
  isPayOffAddressForGAP : boolean | null;
  gapLoanPaidOffRequestInformation?: IGapLoanPaidOffRequestInformation | null;
}
